export default "__VITE_ASSET__Dm2kBess__"